module.exports = __webpack_public_path__ + "static/media/paper.8d89a3b2.jpg";